module.exports = __webpack_public_path__ + "static/media/Headlinetooltipimage.18a602f6.png";